// extracted by mini-css-extract-plugin
export default {"grid":"_1uK-V","weekDays":"_1wFqU","weekDay":"_12ti3","loading":"_3XXD_","week":"_2ic43","days":"_1dpgm"};